import React from 'react';
import { graphql } from 'gatsby';
//import styled from 'styled-components';
import { mergePrismicPreviewData } from 'gatsby-source-prismic';

import { pageSeoData, IS_BROWSER } from '../utils/functions';
import Layout, { SEO } from '../components/Layout';
import { ListCollections } from '../components/Shopify/Collections';
import ListProducts from '../components/ListProducts';
import SliceZone from '../components/SliceZone';

const StorePage = ({ location, data: staticData }) => {
  const previewData = IS_BROWSER && window.__PRISMIC_PREVIEW_DATA__;
  const data = mergePrismicPreviewData({ staticData, previewData });

  const meta = data.prismicStore;
  const page = meta.data;

  console.log(data.shopify.products.edges.length + ' Products Loaded.');

  return (
    <Layout theme={page.page_theme} layout="SidebarLeft">
      <SEO
        title={pageSeoData(meta).title}
        desc={pageSeoData(meta).desc}
        banner={pageSeoData(meta).banner}
        pathname={pageSeoData(meta).pathname}
        firstDate={pageSeoData(meta).firstDate}
        lastDate={pageSeoData(meta).lastDate}
      />
      {page.body ? (
        <div className="gridHeader">
          <SliceZone allSlices={page.body} />
        </div>
      ) : null}
      <div className="gridLeft">
        <ListCollections collections={data.shopify.collections.edges} />
      </div>
      <div className="gridMain">
        <ListProducts input={data.shopify.products.edges} />
      </div>
    </Layout>
  );
};

//available_for_sale:true AND NOT variants.price:0 AND NOT product_type:Hats AND NOT product_type:Shirts AND NOT product_type:Custom Graphics

export const query = graphql`
  query StorePageQuery(
    $uid: String!
    $product_query: String
    $collection_query: String
  ) {
    prismicStore(uid: { eq: $uid }) {
      uid
      first_publication_date
      last_publication_date
      data {
        page_theme
        seo_title
        seo_description
        seo_thumbnail {
          url
        }

        body {
          ... on PrismicStoreBodyTitleText {
            slice_type
            id
            primary {
              title {
                html
              }
              subtitle {
                html
              }
              description {
                html
              }
              align_text
              button_label
              button_link {
                link_type
                url
                target
                type
                uid
                id
              }
              align_image
              thumbnail {
                alt
                copyright
                url
                dimensions {
                  width
                  height
                }
                thumbnails {
                  tiny {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                  small {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                  medium {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                  large {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                }
              }
              scale_module_text
              scale_module_spacing
              theme_color_dark
              theme_color_light
              theme_module
              video {
                embed_url
                title
                thumbnail_url
                thumbnail_width
                thumbnail_height
                type
              }
            }
            items {
              icon {
                alt
                copyright
                url
                dimensions {
                  width
                  height
                }
                thumbnails {
                  tiny {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                  small {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                  medium {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                  large {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                }
              }
            }
          }
          ... on PrismicStoreBodyTitleLogo {
            slice_type
            id
            primary {
              color
              logo {
                url
                thumbnails {
                  tiny {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                  small {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                  medium {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                  large {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                }
                dimensions {
                  width
                  height
                }
                alt
              }
              scale_module_spacing
              scale_module_text
              theme_color_dark
              theme_color_light
              theme_module
            }
          }
          ... on PrismicStoreBodyText {
            slice_type
            id
            primary {
              text {
                html
              }
              scale_module_spacing
              scale_module_text
              theme_color_dark
              theme_color_light
              theme_module
            }
          }
          ... on PrismicStoreBodyHeroReviews {
            id
            slice_type
            primary {
              layout
              height
              align_text
              description {
                html
              }
              title {
                html
              }
              subtitle {
                html
              }
              scale_module_spacing
              scale_module_text
              theme_color_dark
              theme_color_light
              theme_module
            }
          }
          ... on PrismicStoreBodyHeroTweet {
            slice_type
            id
            primary {
              account
              link {
                embed_url
                type
                version
                title
                author_name
                author_url
                provider_name
                provider_url
                thumbnail_url
                thumbnail_width
                thumbnail_height
                html
                name
              }
              scale_module_spacing
              scale_module_text
              theme_color_dark
              theme_color_light
              theme_module
            }
          }
          ... on PrismicStoreBodyHeroStats {
            id
            slice_type
            primary {
              layout
              scale_module_spacing
              scale_module_text
              theme_color_dark
              theme_module
              theme_color_light
            }
            items {
              title
              description {
                html
              }
              counter_start
              counter_end
              counter_prefix
              counter_suffix
              color
              icon {
                alt
                dimensions {
                  width
                  height
                }
                url
                thumbnails {
                  tiny {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                  small {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                  medium {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                  large {
                    dimensions {
                      width
                      height
                    }
                    url
                    alt
                  }
                }
              }
            }
          }
          ... on PrismicStoreBodyHeroVideo {
            slice_type
            id
            primary {
              size
              video {
                embed_url
                title
                thumbnail_url
                thumbnail_width
                thumbnail_height
                type
              }
              scale_module_spacing
              scale_module_text
              theme_color_dark
              theme_color_light
              theme_module
            }
          }
          ... on PrismicStoreBodyHeroProjects {
            slice_type
            id
            primary {
              project_type
              item_width
              scale_module_spacing
              scale_module_text
              theme_color_dark
              theme_color_light
              theme_module
            }
            items {
              project {
                document {
                  ... on PrismicClient {
                    ...prismicClientProject
                  }
                }
              }
            }
          }
          ... on PrismicStoreBodyHeroProfile {
            slice_type
            id
            primary {
              staff {
                document {
                  ...prismicStaffCard
                }
              }
              scale_module_spacing
              scale_module_text
            }
          }

          ... on PrismicStoreBodyHeroTestimonial {
            slice_type
            id
            primary {
              link {
                url
                type
                link_type
              }
              content {
                html
              }
              scale_module_spacing
              scale_module_text
              theme_color_dark
              theme_color_light
              theme_module
              author_name
              author_label
              avatar {
                alt
                copyright
                url
                dimensions {
                  width
                  height
                }
                thumbnails {
                  tiny {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                  small {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                  medium {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                  large {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                }
              }
            }
          }
          ... on PrismicStoreBodyShopifyHero {
            slice_type
            id
            items {
              product {
                id
              }
            }
            primary {
              layout_type
              scale_module_spacing
              scale_module_text
              theme_color_dark
              theme_color_light
              theme_module
            }
          }
          ... on PrismicStoreBodyShopifyCollections {
            slice_type
            id
            primary {
              collection_limit
              collection_query
              collection_reverse
              collection_sortkey
              product_query
              product_reverse
              product_sortkey
              scale_module_spacing
              scale_module_text
              theme_color_dark
              theme_color_light
              theme_module
            }
          }
          ... on PrismicStoreBodyListProjects {
            slice_type
            id
            primary {
              project_type
              item_width
              scale_module_spacing
              scale_module_text
              theme_color_dark
              theme_color_light
              theme_module
            }
          }
          ... on PrismicStoreBodyListAssets {
            id
            slice_type
            primary {
              align_text
              title {
                html
              }
              subtitle {
                html
              }
              description {
                html
              }
              scale_module_spacing
              scale_module_text
              theme_color_dark
              theme_color_light
              theme_module
            }
            items {
              label
              background
              download {
                link_type
                url
                target
              }
              file {
                copyright
                url
                alt
                thumbnails {
                  tiny {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                  small {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                  medium {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                  large {
                    dimensions {
                      width
                      height
                    }
                    url
                    alt
                  }
                }
                dimensions {
                  width
                  height
                }
              }
            }
          }
          ... on PrismicStoreBodyListColors {
            id
            slice_type
            primary {
              align_text
              title {
                html
              }
              subtitle {
                html
              }
              description {
                html
              }
              scale_module_spacing
              scale_module_text
              theme_color_dark
              theme_color_light
              theme_module
            }
            items {
              name
              value
            }
          }
          ... on PrismicStoreBodyListLogosClients {
            slice_type
            id
            items {
              client {
                link_type
                url
                target
                type
                uid
                document {
                  ... on PrismicClient {
                    ...prismicClientProject
                  }
                }
              }
            }
            primary {
              align_text
              description {
                html
              }
              title {
                html
              }
              subtitle {
                html
              }
              scale_module_spacing
              scale_module_text
              theme_color_dark
              theme_color_light
              theme_module
            }
          }
          ... on PrismicStoreBodyListLogosAny {
            slice_type
            id
            items {
              logo {
                alt
                dimensions {
                  width
                  height
                }
                url
                thumbnails {
                  tiny {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                  small {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                  medium {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                  large {
                    dimensions {
                      width
                      height
                    }
                    url
                    alt
                  }
                }
              }
            }
          }
          ... on PrismicStoreBodyListFaq {
            slice_type
            id
            items {
              faq_answer {
                html
              }
              faq_question
            }
            primary {
              faq_section
              faq_description
              scale_module_spacing
              scale_module_text
              theme_color_dark
              theme_color_light
              theme_module
            }
          }
          ... on PrismicStoreBodyListStaff {
            slice_type
            id
            items {
              member {
                document {
                  ... on PrismicStaff {
                    ...prismicStaffCard
                  }
                }
              }
            }
            primary {
              align_text
              description {
                html
              }
              title {
                html
              }
              subtitle {
                html
              }
            }
          }
          ... on PrismicStoreBodyListImages {
            slice_type
            id
            primary {
              title {
                html
              }
              subtitle {
                html
              }
              description {
                html
              }
              align_text
              scale_module_spacing
              scale_module_text
              theme_color_dark
              theme_color_light
              theme_module
            }
          }
          ... on PrismicStoreBodyListBlocks {
            slice_type
            id
            items {
              heading {
                html
              }
              rich_text {
                html
              }
              theme_module
            }
            primary {
              scale_module_spacing
              scale_module_text
              theme_color_dark
              theme_color_light
            }
          }
          ... on PrismicStoreBodyListSteps {
            slice_type
            id
            items {
              heading {
                html
              }
              rich_text {
                html
              }
              thumbnail {
                alt
                dimensions {
                  width
                  height
                }
                url
                thumbnails {
                  tiny {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                  small {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                  medium {
                    url
                    dimensions {
                      width
                      height
                    }
                    alt
                  }
                  large {
                    dimensions {
                      width
                      height
                    }
                    url
                    alt
                  }
                }
              }
              step
            }
            primary {
              scale_module_spacing
              scale_module_text
              theme_color_dark
              theme_color_light
              theme_module
            }
          }
          ... on PrismicStoreBodyIframe {
            slice_type
            id
            primary {
              name
              link {
                embed_url
                title
              }
            }
          }
        }
      }
    }
    shopify {
      products(
        first: 250
        reverse: true
        sortKey: CREATED_AT
        query: $product_query
      ) {
        edges {
          ...shopifyProductCard
        }
      }
      collections(
        first: 250
        reverse: true
        sortKey: TITLE
        query: $collection_query
      ) {
        edges {
          ...shopifyCollectionCard
        }
      }
    }
  }
`;

/*
on PrismicStoreBodyShopifyHero {
  slice_type
  id
  primary {
    layout_type
  }
  items {
    product {
      link_type
      url
      target
      type
      uid
    }
  }
} */
export default StorePage;
/*
collections(first: 5, sortKey: UPDATED_AT) {
  edges {
    ...shopifyCollectionCard
  }
}
 */
